import { render, staticRenderFns } from "./merchantCourse.vue?vue&type=template&id=01560128&scoped=true"
import script from "./merchantCourse.vue?vue&type=script&lang=js"
export * from "./merchantCourse.vue?vue&type=script&lang=js"
import style0 from "./merchantCourse.vue?vue&type=style&index=0&id=01560128&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01560128",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01560128')) {
      api.createRecord('01560128', component.options)
    } else {
      api.reload('01560128', component.options)
    }
    module.hot.accept("./merchantCourse.vue?vue&type=template&id=01560128&scoped=true", function () {
      api.rerender('01560128', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/merchantAccount/detail-pane/merchantCourse.vue"
export default component.exports